'use strict';
const	ComponentFactory	= require('factories/Component')
		, React				= require('react')
		, style				= require('./form.style')
		, Formsy			= require('formsy-react')
		;

module.exports = ComponentFactory.create({
	displayName : 'Form',
	// methods : {
	// 	reset : function(){
	// 		this.refs.form.setFormPristine();
	// 		this.refs.form.reset();
	// 	}
	// },
	render : function(){
		return (
			<Formsy.Form noValidate {...this.props} ref="form">
				{this.props.children}
			</Formsy.Form>
		)
	}
})



// WEBPACK FOOTER //
// resources/modules/decorators/form/form.jsx